import BulkModal from './bulk-edit-modal.connect'

export default BulkModal
